

<!DOCTYPE>
<html xmlns="https://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
  xmlns:o="urn:schemas-microsoft-com:office:office" style="background-color: white;">

<head>
  <title>Evolvtax</title>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0 ">
  <meta name="format-detection" content="telephone=no">
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800" rel="stylesheet">
  <style type="text/css">
    body {
      margin: 0 !important;
      padding: 0 !important;
      -webkit-text-size-adjust: 100% !important;
      -ms-text-size-adjust: 100% !important;
      -webkit-font-smoothing: antialiased !important;
    }

    img {
      /*border: 0 !important;*/
      outline: none !important;
    }

    p {
      Margin: 0px !important;
      Padding: 0px !important;
    }

    table {
      /*border-collapse: collapse;*/
      mso-table-lspace: 0px;
      mso-table-rspace: 0px;
    }

    td,
    a,
    span {
      /*border-collapse: collapse;*/
      mso-line-height-rule: exactly;
    }

    .ExternalClass * {
      line-height: 100%;
    }

    .em_defaultlink a {
      color: inherit !important;
      text-decoration: none !important;
    }

    span.MsoHyperlink {
      mso-style-priority: 99;
      color: inherit;
    }

    span.MsoHyperlinkFollowed {
      mso-style-priority: 99;
      color: inherit;
    }

    @media only screen and (min-width:481px) and (max-width:699px) {
      .em_main_table {
        width: 100% !important;
      }

      .em_wrapper {
        width: 100% !important;
      }

      .em_hide {
        display: none !important;
      }

      .em_img {
        width: 100% !important;
        height: auto !important;
      }

      .em_h20 {
        height: 20px !important;
      }

      .em_padd {
        padding: 20px 10px !important;
      }
    }

    @media screen and (max-width: 480px) {
      .em_main_table {
        width: 100% !important;
      }

      .em_wrapper {
        width: 100% !important;
      }

      .em_hide {
        display: none !important;
      }

      .em_img {
        width: 100% !important;
        height: auto !important;
      }

      .em_h20 {
        height: 20px !important;
      }

      .em_padd {
        padding: 20px 10px !important;
      }

      .em_text1 {
        font-size: 16px !important;
        line-height: 24px !important;
      }

      u+.em_body .em_full_wrap {
        width: 100% !important;
        width: 100vw !important;
      }
    }
  </style>
</head>

<body class="em_body" style="margin:0px; padding:0px; background-color: white;">
  <table class="em_full_wrap" valign="top" width="100%" cellspacing="0" cellpadding="0" bgcolor="white" align="center">

    <tbody>
      <tr>
        <td valign="top" align="center">
          <table class="em_main_table" style="width:700px; background-color: #f6f7f8;" width="700" cellspacing="0"
            cellpadding="0" align="center">
            <!--Header section-->
            <tbody>

              <tr>
                <td style="padding:15px;" class="em_padd" valign="top" bgcolor="#f6f7f8" align="center">
                  <table width="100%" cellspacing="0" cellpadding="0" align="center">

                    <tbody>
                      <tr><br>
                        <td style="text-align: -webkit-center;">
                          <img src="https://evolvtax.com/assets/images/logo.png" alt="yt"
                            style="display:block; font-family:Arial, sans-serif; font-size:14px; line-height:14px; color:#ffffff;">
                          
                          <!-- <p style="text-align:center; font-family:Arial, sans-serif; font-size:14px;">Welcome to Evolv
                            Tax !</p> -->

                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <!--//Header section-->
              <!--Banner section-->
              <!-- <tr>

                <td valign="top" align="center">
                  <table width="100%" cellspacing="0" cellpadding="0" align="center">

                    <tbody>
                      <tr>
                        <td
                          style="font-family:'Open Sans', Arial,        sans-serif; font-size:16px;             line-height:30px; color:#ffffff;"
                          valign="top" align="center">This is a sample email which shall be accommodated in a single
                          paragraph
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr> -->
              <!--//Banner section-->
              <!--Content Text Section-->
              <tr style="text-align: center;">
                <td>
                    <img style="margin-left: auto;margin-top: auto;" src ="../../assets/images/verify.svg">
                </td>
            </tr>
            <tr>
              <tr>

                <td class="em_padd">

                  <table width="100%" cellspacing="0" cellpadding="0" style="text-align: center;">

                    <tbody style="text-align: center;">
                      <!-- <tr>
                        <td
                          style="font-family:'Open Sans', Arial,sans-serif; font-size:16px;line-height:30px; color:#ffffff;">
                          <p style="color: red;"> Dear <span style="color: blue;"> {name} </span> </p> <br>

                        </td>
                      </tr> -->
                      <!-- <tr>
                        <td 
                          style="font-family:'Open Sans', Arial, sans-serif; font-size:16px;line-height:30px; color:black; text-align: center;"
                          valign="top">Your Email Is Successfully<strong style="color: red;"> Verified </strong>

                        </td>
                      </tr> -->
                      <!-- <tr>
                        <td>
                          <p style="color: red;">{email} </p>

                        </td>
                      </tr> --><br>
                      <tr>
                          <td
                          style="font-family:'Open Sans', Arial, sans-serif; font-size:18px; line-height:22px; color:#fbeb59; letter-spacing:2px; padding-bottom:12px;"
                          valign="top" align="center"><button style=" border: none;
                          background-color: #f0aa2a;
                          color: white;
                          
                          text-align: center;
                          text-decoration: none;
                          display: inline-block;
                          font-size: 16px;
                          margin: 4px 2px;
                          cursor: pointer;" type="button" class="btn btn-primary"><a href="login" target="_blank" style="color: white;">Click To Login </a></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <!--//Content Text Section-->
              <!--Footer Section-->
              <tr>
                <td style="padding:16px 30px;" class="em_padd" valign="top" bgcolor="#f6f7f8" align="center">
                  <table width="100%" cellspacing="0" cellpadding="0" align="center" style="text-align: center;">

                    <tbody style="text-align: center;">

                      <tr>
                        <td
                          style="font-family:'Open Sans', Arial, sans-serif; font-size:10px; line-height:22px; color:#fbeb59; letter-spacing:2px; padding-bottom:8px;">
                          <a href="https://evolvtax.com/">Have a question? Visit Evolv Tax
                            support page.</a>
                        </td>
                      </tr>



                      <tr>
                        <td style="font-family:'Open Sans', Arial, sans-serif; 
                                    font-size:9px; line-height:22px;  background-color: coral;
 color:#fbeb59; text-transform:uppercase; letter-spacing:2px; padding-bottom:8px;"> All
                          Copyrights Reserved @ & Evolvtax.com
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="em_hide" style="line-height:1px;min-width:700px;background-color:#ffffff;">
                  <img alt="" src="images/spacer.gif"
                    style="max-height:1px; min-height:1px; display:block; width:700px; min-width:700px;" width="700"
                    height="1">
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>

</body>

</html>